<i18n src="../../locales/lang.json"></i18n>

<template>
  <div id="editProcedureMenu" class="nested-menu" style="display:none;">
  <!--Hide the menu, we are testing not to use it at all..-->
  <nested-draggable-menu v-bind:isroot="true" v-bind:parentexpanded="true" ref="nestedMenu" style="position: fixed; margin-top: 30px; right: 68px; z-index: 1002;"></nested-draggable-menu>
  </div>
  
</template>

<script>
  
  var menu = [];

  export default {
    name: "procedure-editmenu",
    components: {

    },
    data() {
      return {
        menu,
        negative: -1
      };
    },
    computed: {

    },

    methods: {
      doSomething() {
        //this.menu[0].expanded = false;
        this.loadMenu();
        var thisContext = this;
        setTimeout(function () {
          thisContext.menu[0].expanded = true;
          thisContext.$refs.nestedMenu.setData(thisContext.menu);
        }, 500);

      },
      loadMenu() {
        this.$refs.nestedMenu.setData(this.menu);
      },
      getDefaultSettings() {
        var s = {
          Property: {} };
        return s;
      },
    },
    mounted() {
      this.menu = [{
        iconclass: "icon-plus3 icon-2x",
        orientation: "vertical",
        direction: "downleft",
        color: "white",
        bgColor: "yellow",
        static: true,
        childElements: [],
        elements: []
      }];
      /*
      this.menu = [
        {
          iconclass: "icon-plus3 icon-2x",
          orientation: "vertical",
          direction: "downleft",
          color: "white",
          bgColor: "yellow",
          static: true,
          childElements: [],
          elements: [
            {
              iconclass: "icon-typography",
              elementType: 1,
              overRidable: false,
              settings: this.getDefaultSettings(),
              tooltip: this.$t('text'),
              text: this.$t('text'),
              childElements: [],
            },
            {
              iconclass: "icon-checkbox-checked",
              elementType: 2,
              overRidable: false,
              settings: this.getDefaultSettings(),
              tooltip: this.$t('task'),
              text: this.$t('task'),
              childElements: [],
            },
            {
              iconclass: "icon-indent-increase2",
              elementType: 4,
              overRidable: false,
              settings: this.getDefaultSettings(),
              tooltip: this.$t('section'),
              text: this.$t('section'),
              childElements: [],
            },
            {
              iconclass: "icon-attachment",
              elementType: 0,
              overRidable: false,
              settings: this.getDefaultSettings(),
              tooltip: this.$t('image_or_file'),
              text: this.$t('image_or_file'),
              childElements: [],
            },
            {
              iconclass: "icon-qrcode",
              elementType: 9,
              overRidable: false,
              settings: this.getDefaultSettings(),
              tooltip: this.$t('qr_checkpoint'),
              text: this.$t('qr_checkpoint'),
              childElements: [],
            },
            {
              iconclass: "icon-user-plus",
              orientation: "horizontal",
              direction: "spreadleft",
              childElements: [],
              elements: [
                {
                  iconclass: "icon-upload4",
                  overRidable: false,
                  elementType: 5,
                  settings: this.getDefaultSettings(),
                  tooltip: this.$t('user_upload'),
                  text: this.$t('user_upload'),
                  childElements: [],
                  orientation: "horizontal",
                  direction: "spreadleft",
                  elements: [
                    {
                      iconclass: "icon-upload4",
                      elementType: 5,
                      overRidable: false,
                      settings: this.getDefaultSettings(),
                      tooltip: this.$t('user_upload'),
                      text: this.$t('user_upload'),
                      childElements: [],
                    },
                    {
                      iconclass: "icon-camera",
                      elementType: 16,
                      overRidable: false,
                      settings: this.getDefaultSettings(),
                      tooltip: this.$t('camera'),
                      text: this.$t('camera'),
                      childElements: [],
                    }
                ]
                },
                {
                  iconclass: "icon-pencil5",
                  elementType: 6,
                  overRidable: false,
                  settings: this.getDefaultSettings(),
                  tooltip: this.$t('user_text'),
                  text: this.$t('user_text'),
                  childElements: [],
                },
                {
                  iconclass: "icon-pencil6",
                  elementType: 7,
                  overRidable: false,
                  settings: this.getDefaultSettings(),
                  tooltip: this.$t('user_long_text'),
                  text: this.$t('user_long_text'),
                  
                  childElements: [],
                },
                {
                  iconclass: "icon-list",
                  elementType: 8,
                  overRidable: true,
                  settings: this.getDefaultSettings(),
                  tooltip: this.$t('user_select'),
                  text: this.$t('user_select'),
                  childElements: [],
                },
                {
                  iconclass: "icon-bubble-notification",
                  elementType: 10,
                  overRidable: false,
                  settings: this.getDefaultSettings(),
                  tooltip: this.$t('worknote'),
                  text: this.$t('worknote'),
                  childElements: [],
                },
              ]
            },
            {
              iconclass: "icon-gallery",
              orientation: "horizontal",
              direction: "spreadleft",
              childElements: [],
              elements: [
                {
                  iconclass: "icon-touch",
                  elementType: 11,
                  overRidable: false,
                  settings: this.getDefaultSettings(),
                  tooltip: this.$t('button'),
                  text: this.$t('button'),
                  childElements: [],
                },
                {
                  iconclass: "icon-versions",
                  overRidable: false,
                  settings: this.getDefaultSettings(),
                  tooltip: this.$t('slideshow'),
                  orientation: "horizontal",
                  direction: "downleft",
                  elements: [
                    {
                      iconclass: "icon-versions",
                      elementType: 12,
                      overRidable: false,
                      settings: this.getDefaultSettings(),
                      tooltip: this.$t('slideshow'),
                      childElements: [{
                        Id: -1,
                        TaskId: -1,
                        Name: 'StartPage',
                        Text: "Start page",
                        ElementType: 13,
                        Settings: this.getDefaultSettings(),
                        OverRidable: false,
                        Elements: [],
                        Url: "",
                        IsChanged: true,
                        ParentId: null,
                        UserInputs: []
                      },
                        {
                          Id: -1,
                          TaskId: -1,
                          Name: 'StartPage',
                          Text: "Next page",
                          ElementType: 13,
                          Settings: this.getDefaultSettings(),
                          OverRidable: false,
                          Elements: [],
                          Url: "",
                          IsChanged: true,
                          ParentId: null,
                          UserInputs: []
                        },
                        {
                          Id: -1,
                          TaskId: -1,
                          Name: 'End page',
                          Text: "End page",
                          ElementType: 14,
                          Settings: this.getDefaultSettings(),
                          OverRidable: false,
                          Elements: [],
                          Url: "",
                          IsChanged: true,
                          ParentId: null,
                          UserInputs: []
                        }],
                    },
                    {
                      iconclass: "icon-pagebreak",
                      elementType: 13,
                      overRidable: false,
                      settings: this.getDefaultSettings(),
                      tooltip: this.$t('new_page'),
                      childElements: [],
                    },
                    {
                      iconclass: "icon-pagebreak",
                      elementType: 15,
                      overRidable: false,
                      settings: this.getDefaultSettings(),
                      tooltip: this.$t('page_ending'),
                      childElements: [],
                    },
                    
                  ],
                   childElements: [],
                },
                {
                  iconclass: "icon-calendar2",
                  elementType: 17,
                  overRidable: false,
                  settings: this.getDefaultSettings(),
                  tooltip: this.$t('calendar'),
                  childElements: [],
                }

              ]
            }
          ]
        }
      ]
  */
      

      this.loadMenu();
      this.$root.$on('procedure_refresh', this.doSomething);
      this.$root.$on('procedure_loaded', this.doSomething);
    }
  };

</script>



// WEBPACK FOOTER //
// src/components/procedure/procedure-editmenu.vue